import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const SHOPIFY_SALES_CHANNEL_SUCCESS = 'SHOPIFY_SALES_CHANNEL_SUCCESS';
export const SHOPIFY_SALES_CHANNEL_LOADING = 'SHOPIFY_SALES_CHANNEL_LOADING';

const { ShopifySalesByChannel: { getShopifySalesByReferrer } } = apiUrls;


export const getShopifySalesByChannelDetails = ({
  fromYear, toYear, fromMonth, toMonth
}) => async (dispatch) => {
  try {
    const { url } = getShopifySalesByReferrer
    const requestData = {
      ...getShopifySalesByReferrer,
      url,
      data: {
          fromYear,
          fromMonth,
          toYear,          
          toMonth
          }  
  };
    const data = await REQUEST(requestData);
    dispatch({
      type: SHOPIFY_SALES_CHANNEL_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: SHOPIFY_SALES_CHANNEL_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: SHOPIFY_SALES_CHANNEL_LOADING,
    isLoading
  })
}
